export default __webpack_public_path__ + "static/media/womanSitting.6331672d.svg";